"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// All project specific translations
var Projects = {
  // ESN Management
  esn_management_login: {
    nl: "Meld je aan op OSN Management",
    fr: "Connectez-vous à OSN Management",
    en: "Log into OSN Management",
    de: "Melden Sie sich bei OSN Management an"
  },
  esn_management_description: {
    nl: "Met OSN Management kunt u alle gegevens van ondernemers op het Ondernemersnetwerk beheren, zoals openingstijden, advertenties, videotheek en meer.",
    fr: "Avec OSN Management, vous pouvez gérer toutes les données des entrepreneurs sur le Réseau Entrepreneurs, telles que les heures d'ouverture, la publicité, la vidéothèque, etc.",
    en: "With OSN Management, you can manage all the entrepreneurs' data of the Entrepreneurs Network such as opening hours, advertisement, video library and more.",
    de: "Mit OSN Management können Sie alle Daten von Unternehmern im Unternehmernetzwerk verwalten, wie Öffnungszeiten, Werbung, Videothek und mehr."
  },
  most_privacy_friendly: {
    nl: "<h1>Meest <strong>privacyvriendelijke</strong> en relevante zoekresultaten van <strong>alle Belgische ondernemers</strong></h1>",
    fr: "<h1>Le moteur de recherche <strong>le plus confidentiel</strong> avec des résultats adaptés à votre recherche <strong>des entrepreneurs belges</strong></h1>",
    en: "<h1>Most <strong>privacy-friendly</strong> and relevant search results <strong>of all Belgian entrepreneurs</strong></h1>",
    de: "<h1>Die <strong>datenschutzfreundlichsten</strong> und relevantesten Suchergebnisse <strong>aller belgischen Unternehmer</strong></h1>"
  },
  logo_alt: {
    nl: "Logo Ondernemersnetwerk",
    fr: "Logo Réseau Entrepreneurs",
    en: "Logo Entrepreneursnetwork",
    de: "Logo Unternehmernetzwerk"
  }
};
var _default = Projects;
exports["default"] = _default;